import { createAction } from 'redux-actions';

import { saveDisplaySettings } from './save-display-settings';

const updateHasDismissedImportEmployeeListMessageAction = createAction(
  'UPDATE_HAS_DISMISSED_IMPORT_EMPLOYEE_LIST_MESSAGE',
);

export const updateHasDismissedImportEmployeeListMessage =
  (username: string, dismissed: boolean) => (dispatch: Function, getState: Function) => {
    dispatch(updateHasDismissedImportEmployeeListMessageAction({ username, dismissed }));
    saveDisplaySettings(getState());
  };
